import { ArrowRight } from "lucide-react";

const works = [
  {
    src: "/brand/wrapped-furniture.jpg",
    title: "Wrap. Pad. Protect.",
    desc: "Every piece blanket-wrapped and shrink-sealed before it leaves the room. Walls stay scuff-free. Furniture stays scratch-free.",
    tag: "ON-SITE PREP",
    span: "row-span-2",
  },
  {
    src: "/brand/pods-load.jpg",
    title: "Tetris-grade loading.",
    desc: "Maximizing every cubic foot of a 16ft PODS container. Heavy at the base, light on top, locked tight.",
    tag: "CONTAINER LOAD",
    span: "",
  },
  {
    src: "/brand/container-load.jpg",
    title: "Containers · We load & unload.",
    desc: "PODS, U-Box, freight trailers, shipping containers — we pro-load with tarp dividers, stacked totes, and tie-down anchors to stop shifting in transit.",
    tag: "U-BOX · FREIGHT",
    span: "",
  },
  {
    src: "/brand/storage-organized.jpg",
    title: "Storage you can find later.",
    desc: "Labeled bins. Stacked totes. Boxes facing out. When you need that one item, we know exactly where it is.",
    tag: "STORAGE",
    span: "",
  },
];

export default function Gallery() {
  return (
    <section
      id="work"
      className="py-24 lg:py-32 bg-black text-white"
      data-testid="gallery-section"
    >
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <div className="overline text-[#5BB239]">Real Work · Real Jobs</div>
            <h2 className="mt-3 font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[0.95] max-w-2xl">
              No stock photos.<br />
              <span className="text-[#5BB239]">Just our work.</span>
            </h2>
          </div>
          <p className="max-w-md text-white/60 leading-relaxed text-sm">
            These are actual jobs from actual customers. Same care, same standard,
            every time the truck rolls out.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6 md:grid-rows-2 md:auto-rows-fr">
          {works.map((w, i) => (
            <article
              key={i}
              className={`group relative overflow-hidden bg-[#111] ${w.span} ${
                i === 0 ? "md:col-span-2 lg:col-span-1 md:row-span-2" : ""
              } min-h-[300px]`}
              data-testid={`gallery-item-${i}`}
            >
              <img
                src={w.src}
                alt={w.title}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/95 via-black/50 to-black/10" />
              <div className="absolute inset-x-0 bottom-0 p-6 lg:p-8">
                <div className="font-mono-label text-[10px] text-[#5BB239]">{w.tag}</div>
                <h3 className="mt-2 font-display font-black text-2xl lg:text-3xl tracking-tight leading-tight">
                  {w.title}
                </h3>
                <p className="mt-2 text-sm text-white/75 leading-relaxed max-w-md">
                  {w.desc}
                </p>
              </div>
              <div className="absolute top-4 right-4 bg-black/60 backdrop-blur px-2.5 py-1 font-mono-label text-[9px] text-white/80 border border-white/10">
                {String(i + 1).padStart(2, "0")} / {String(works.length).padStart(2, "0")}
              </div>
            </article>
          ))}
        </div>

        <div className="mt-12 flex items-center justify-between flex-wrap gap-4 pt-10 border-t border-white/10">
          <div className="font-mono-label text-[11px] text-white/50">
            Want to see your move done like this?
          </div>
          <a
            href="#book"
            className="group inline-flex items-center gap-3 bg-[#5BB239] text-black px-6 py-3 font-bold uppercase tracking-wider text-sm hover:bg-[#499828] hover:text-white transition-colors"
            data-testid="gallery-cta"
          >
            Book My Move
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </a>
        </div>
      </div>
    </section>
  );
}
